import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import "./Dashboard.css";
import { Row, Col, Card, Form, Button, Modal } from "react-bootstrap";
import DashBoardImageSlider from "../../components/cards/DashboardImageSlider";
import {
	LoanCardComponent,
	BusinessCardComponent,
	RevenueCardComponent,
	OrdersCardComponent,
	ReligiousCardComponent,
} from "../../components/cards";
import TotalFamiliesRecord from "../../components/cards/TotalFamiliesRecord";
import PageLayout from "../../layouts/PageLayout";
import { DivideTitleComponent } from "../../components";
import axios from "axios";
import CountCardComponent from "../../components/cards/CountCardComponent";
import ExpendituresCardComponent from "../../components/cards/ExpendituresCardComponent";
import MonthlyChart from "../../components/charts/MonthlyChart";
import PulseLoader from "react-spinners/PulseLoader";
import { SidebarContext } from "../../context/Sidebar";
import UserMap from "./map";
export default function Dashboard() {
	const defaultFilters = {
		ppi: "",
		group: "",
		donor: "",
		business_donor: "",
		from_date: "",
		to_date: "",
	};

	// Get previously saved filters from sessionStorage
	const [appliedFilters, setAppliedFilters] = useState(() => {
		const savedFilters = sessionStorage.getItem("dashboardFilters");

		return savedFilters
			? JSON.parse(savedFilters)
			: defaultFilters;
	});

	const { hasPermission } = useContext(SidebarContext);

	// Form should also start with saved filters
	const [formState, setFormState] = useState(() => {
		const savedFilters = sessionStorage.getItem("dashboardFilters");

		return savedFilters
			? JSON.parse(savedFilters)
			: defaultFilters;
	});

	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	const AuthToken = localStorage.getItem("AuthUser");
	const User = localStorage.getItem("user");

	axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

	const [dData, setDdata] = useState({});

	useEffect(() => {
		setLoading(true);

		const savedFilters = sessionStorage.getItem("dashboardFilters");

		const filters = savedFilters
			? JSON.parse(savedFilters)
			: defaultFilters;

		const params = {};

		if (filters?.ppi) {
			params.req_id = filters.ppi;
		}

		if (filters?.group) {
			params.org = filters.group;
		}

		if (filters?.from_date) {
			params.from_date = filters.from_date;
		}

		if (filters?.to_date) {
			params.to_date = filters.to_date;
		}

		if (filters?.donor) {
			params.donor = filters.donor;
		}

		axios
			.get(`${process.env.REACT_APP_API_URL}/dashboard`, { params })
			.then((res) => {
				setDdata(res.data);
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;

		const updatedState = {
			...formState,
			[name]: value,
		};

		if (name === "ppi" && value) {
			updatedState.group = "";
			updatedState.donor = "";
		}

		if (name === "group" && value) {
			updatedState.ppi = "";
			updatedState.donor = "";
		}

		if (name === "donor" && value) {
			updatedState.ppi = "";
			updatedState.group = "";
		}

		setFormState(updatedState);

		const { from_date, to_date } = updatedState;

		if (
			(from_date &&
				to_date &&
				new Date(to_date) >= new Date(from_date)) ||
			(!from_date && !to_date)
		) {
			setError("");
		}
	};

	const handleApplyFilter = () => {
		const { from_date, to_date } = formState;

		if (from_date && !to_date) {
			setError("Please select a 'To Date' when 'From Date' is chosen.");
			return;
		}

		if (!from_date && to_date) {
			setError("Please select a 'From Date' when 'To Date' is chosen.");
			return;
		}

		if (
			from_date &&
			to_date &&
			new Date(to_date) < new Date(from_date)
		) {
			setError("'To Date' cannot be earlier than 'From Date'.");
			return;
		}

		setError("");

		setAppliedFilters(formState);

		// Save filters in sessionStorage
		sessionStorage.setItem(
			"dashboardFilters",
			JSON.stringify(formState)
		);

		const params = {};

		if (formState?.ppi) {
			params.req_id = formState.ppi;
		}

		if (formState?.group) {
			params.org = formState.group;
		}

		if (formState?.from_date) {
			params.from_date = formState.from_date;
		}

		if (formState?.to_date) {
			params.to_date = formState.to_date;
		}

		if (formState?.donor) {
			params.donor = formState.donor;
		}
		setLoading(true);
		axios
			.get(`${process.env.REACT_APP_API_URL}/dashboard`, { params })
			.then((res) => {
				setDdata(res.data);
				setLoading(false)
			})
			.catch((err) => {
				console.error(err);
			});

		handleClose();
	};

	const clearFilters = () => {
		setLoading(true)
		const cleared = {
			ppi: "",
			group: "",
			donor: "",
			business_donor: "",
			from_date: "",
			to_date: "",
		};

		// Remove saved filters
		sessionStorage.removeItem("dashboardFilters");

		setAppliedFilters(cleared);
		setFormState(cleared);
		setError("");

		axios
			.get(`${process.env.REACT_APP_API_URL}/dashboard`)
			.then((res) => {
				setDdata(res.data);
				setLoading(false);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	const handleClose = () => setShow(false);

	const handleShow = () => {
		setFormState(appliedFilters);
		setShow(true);
	};

	const [show, setShow] = useState(false);

	const { t } = useContext(TranslatorContext);

	return (
		<PageLayout>
			<Row>
				<Col xl={12}>
					<div className="mc-card">
						<div className="mc-breadcrumb">
							<h3 className="mc-breadcrumb-title">Dashboard</h3>
							<div className="mc-breadcrumb-separator">
								{loading ? (
									<>
										Loading Dashboard Data
										<PulseLoader
											color="#077834"
											style={{ display: "inline" }}
											loading={loading}
											size={6}
										/>
									</>
								) : (

									""
								)}
							</div>
							<ul className="mc-breadcrumb-list">
								<li className="mc-breadcrumb-item">
									<Link
										to="#"
										className="mc-breadcrumb-link"
										style={{ color: "#077834" }}
									>
										{t("home")}
									</Link>
								</li>
								<li className="mc-breadcrumb-item">
									Dashboard
								</li>
							</ul>
						</div>
					</div>
				</Col>

				<Col
					xs={12}
					xl={4}
				>
					<DashBoardImageSlider images={dData?.families_images || []} />

					{!appliedFilters.from_date &&
						!appliedFilters.to_date &&
						!appliedFilters.donor &&
						!appliedFilters.group &&
						!appliedFilters.ppi ? (
						<Button
							style={{ backgroundColor: "#077834", marginBottom: "15px" }}
							className="w-100 text-light"
							onClick={handleShow}
						>
							Filter Dashboard
						</Button>
					) : (
						<div className="d-flex " >
							<Button
								className="flex-fill p-3 text-light"
								style={{
									backgroundColor: "#077834",
									border: "none",
									marginBottom: "15px",
								}}
								onClick={handleShow}
							>
								Apply Filter
							</Button>

							<Button
								className="flex-fill p-3"
								variant="secondary"
								onClick={clearFilters}
								style={{

									marginBottom: "15px",
								}}
							>
								Clear Filters
							</Button>
						</div>
					)}
				</Col>

				<Col
					xs={12}
					xl={8}
				>
					<Row
						xs={1}
						sm={2}
					>
						<TotalFamiliesRecord
							data={dData}
							formState={formState}
						/>
					</Row>
				</Col>

				<CountCardComponent data={dData} formState={formState} />
				{User?.id < 8 && <>
					<Col xl={8}>
						<RevenueCardComponent
							data={dData}
							formState={formState}
						/>
					</Col>
					<Col xl={4}>
						<OrdersCardComponent data={dData} />{" "}
					</Col>
				</>}
			</Row>
			<Row>
				<Col
					sm={12}
					lg={12}
				>
					<DivideTitleComponent
						title={t("Expenditures")}
						className="mb-4 mt-3"
					/>
					<Row>
						<ExpendituresCardComponent
							data={dData}
							formState={formState}
						/>
					</Row>
				</Col>
				<Col
					md={12}
					className="mb-3"
				>
					<DivideTitleComponent
						title={t(`${new Date().getFullYear()} Data Report`)}

						className="mb-4 mt-3"
					/>
					<Card style={{ height: 400, border: "none", padding: 5 }}>
						<MonthlyChart data={dData?.rescue_draft} />
					</Card>
				</Col>
				<Col lg={12}>
					<BusinessCardComponent
						businessTypes={dData?.business_types}
						formState={formState}
					/>
				</Col>
				<Col lg={12}>
					<ReligiousCardComponent
						faiths={dData?.faiths}
						data={dData}
						formState={formState}
					/>
				</Col>
				<Col lg={12}>
					<LoanCardComponent loanTypes={dData?.loan_types} formState={formState} />
				</Col>
				<Col>
					<UserMap />
				</Col>
				{/* <Col xl={12}>
          {" "}
          <ActivityCardComponent />{" "}
        </Col> */}
			</Row>
			{/* here is my modal for filter  */}
			<Modal
				show={show}
				onHide={handleClose}
				centered
				size="md"
				className="filter-dashboard-modal"
			>
				<Modal.Header className="dashboard-header m-0 border-bottom">
					<Modal.Title className="text-center w-100 pt-2">
						<h2 className="fw-bold">Filter Dashboard</h2>
					</Modal.Title>
					<button
						type="button"
						className="btn-close"
						aria-label="Close"
						onClick={handleClose}
						style={{ marginRight: "12px" }}
					/>
				</Modal.Header>

				<Modal.Body className="dashboard-body bg-white flex-column pb-3">
					<div className="mt-4 w-100">
						<h6
							className="text-start pl-3"
							style={{ fontWeight: 700, fontSize: "13px" }}
						>
							FILTER BY DATE RANGE :
						</h6>

						<div className="d-flex flex-row gap-2">
							<Form.Group className="w-100 mt-3">
								<Form.Label className="text-start">From:</Form.Label>
								<Form.Control
									name="from_date"
									type="date"
									value={formState.from_date}
									onChange={handleChange}
									className="w-100"
								/>
							</Form.Group>

							<Form.Group className="w-100 mt-3">
								<Form.Label className="text-start">To:</Form.Label>
								<Form.Control
									name="to_date"
									type="date"
									value={formState.to_date}
									onChange={handleChange}
									className="w-100"
								/>
							</Form.Group>
						</div>

						{error && (
							<div className="text-danger mt-2" style={{ fontSize: "13px" }}>
								{error}
							</div>
						)}

						{/* Permission-based Filters */}
						{hasPermission("FilterByRequest") && (
							<Form.Group className="w-100 mb-3 mt-3">
								<Form.Label>Filter By Request ID :</Form.Label>
								<Form.Select
									name="ppi"
									value={formState.ppi}
									onChange={handleChange}
									className="w-100"
								>
									<option value="">Select...</option>
									{dData.family_requests?.map((req) => (
										<option key={req.id} value={req.id}>
											{req.rfq_id}
										</option>
									))}
								</Form.Select>
							</Form.Group>
						)}

						{hasPermission("FilterByOrganizations") && (
							<Form.Group className="w-100 mb-3">
								<Form.Label>Filter By Organizations :</Form.Label>
								<Form.Select
									name="group"
									value={formState.group}
									onChange={handleChange}
									className="w-100"
								>
									<option value="">Select...</option>
									{dData.organizations?.map((org) => (
										<option key={org.id} value={org.id}>
											{org.name}
										</option>
									))}
								</Form.Select>
							</Form.Group>
						)}

						{hasPermission("FilterByDonors") && (
							<Form.Group className="w-100 mb-3">
								<Form.Label>Filter By Donors :</Form.Label>
								<Form.Select
									name="donor"
									value={formState.donor}
									onChange={handleChange}
									className="w-100"
								>
									<option value="">Select...</option>
									{dData.donors?.map((req) => (
										<option key={req.id} value={req.id}>
											{req.name}
										</option>
									))}
								</Form.Select>
							</Form.Group>
						)}
					</div>
				</Modal.Body>

				<Modal.Footer className="dashboard-footer bg-white m-0 border-top">
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
					<Button onClick={handleApplyFilter} style={{ backgroundColor: "#077834" }}>
						Apply Filter
					</Button>
				</Modal.Footer>
			</Modal>
		</PageLayout>
	);
}
